import React from 'react';
import AboutUs from '../AboutUs/AboutUs';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import './About.css';

const About = () => {
    return (
        <div>
          <AboutUs></AboutUs>
          <Footer></Footer>
        </div>
    );
};

export default About;